export type Lang = 'ko' | 'en'

// Use a mapped type so every locale satisfies the same interface
export type Translations = {
  nav: { about: string; products: string; contact: string; blog: string }
  hero: { label: string; words: readonly string[]; headline: string; desc: string; scroll: string }
  about: {
    keywords: readonly string[]
    theme: string
    workNumber: string
    workTitle: string
    cultureNumber: string
    cultureTitle: string
    stackCards: readonly { title: string; desc: string }[]
  }
  work: { label: string; title: string }
  contact: {
    label: string; title: string
    emailLabel: string; phoneLabel: string; addressLabel: string
    nameField: string; namePlaceholder: string
    phoneField: string; phonePlaceholder: string
    emailField: string; emailPlaceholder: string
    typeField: string; typePlaceholder: string
    messageField: string; messagePlaceholder: string
    submit: string
  }
  blog: {
    label: string; title: string; desc: string
    allCategory: string; empty: string; back: string; related: string
    infoLabel: string; authorLabel: string; dateLabel: string
    categoryLabel: string; tagsLabel: string
  }
  footer: {
    rights: string
    desc: string
    contactLabel: string
    links: readonly { label: string; href: string }[]
  }
}

const ko: Translations = {
  // ── Header ──
  nav: {
    about: '소개',
    products: '메뉴와 기준',
    contact: '가맹 문의',
    blog: '라멘 블로그',
  },
  // ── Hero ──
  hero: {
    label: '범계역 일본라멘·덮밥 전문점',
    words: ['끓입니다.', '준비합니다.', '만듭니다.', '함께합니다.'],
    headline: '한 그릇의 기준을\n지켜온 우마이식당',
    desc: '범계 본점에서 지켜온 정통 라멘의 기준을\n다음 매장과 함께 더 넓은 곳에 전합니다.',
    scroll: 'Scroll',
  },
  // ── About ──
  about: {
    keywords: [
      '일본라멘', '돈코츠라멘', '돈골 육수', '호소멘',
      '범계 본점', '안양 맛집', '라멘 창업', '가맹사업',
      '라멘 전문점', '우마이식당',
    ],
    theme: 'Yumai Standard',
    workNumber: '1',
    workTitle: '본점',
    cultureNumber: '3',
    cultureTitle: '기준',
    stackCards: [
      { title: '국내산 돈골', desc: '안양지역에서 직접 발골한 뼈를 공급받아 육수를 끓입니다.' },
      { title: '강한 불의 시간', desc: '매달 가스비 200여만원을 들여 정성으로 깊은 맛을 만듭니다.' },
      { title: '얇은 호소멘', desc: '진한 국물을 더 많이 품을 수 있도록 낮은 가수율의 면을 사용합니다.' },
      { title: '직접 만드는 한 그릇', desc: '전통적인 방법으로 최선을 다해 모든 메뉴를 직접 만듭니다.' },
    ],
  },
  // ── Work ──
  work: {
    label: 'Yumai Standard',
    title: '우마이식당의 기준',
  },
  // ── Contact ──
  contact: {
    label: 'Franchise',
    title: '우마이식당과\n함께 시작하세요',
    emailLabel: 'Instagram',
    phoneLabel: 'Hours',
    addressLabel: 'Address',
    nameField: '이름',
    namePlaceholder: '홍길동',
    phoneField: '연락처',
    phonePlaceholder: '010-0000-0000',
    emailField: '이메일',
    emailPlaceholder: 'hello@example.com',
    typeField: '문의 유형',
    typePlaceholder: '가맹 문의 / 매장 방문 / 단체 예약 / 기타',
    messageField: '메시지',
    messagePlaceholder: '방문 목적, 창업을 고민하는 지역, 궁금한 점을 알려주세요.',
    submit: '문의하기 →',
  },
  // ── Blog ──
  blog: {
    label: 'Blog',
    title: 'What is \nRamen',
    desc: '우마이식당이 라멘의 재료와 조리 원리, 육수와 면, 라멘 문화 이야기를 전합니다.',
    allCategory: '전체',
    empty: '해당 카테고리에 포스트가 없습니다.',
    back: '← 블로그로 돌아가기',
    related: '관련 포스트',
    infoLabel: '포스트 정보',
    authorLabel: '작성자',
    dateLabel: '날짜',
    categoryLabel: '카테고리',
    tagsLabel: '태그',
  },
  // ── Footer ──
  footer: {
    rights: 'All rights reserved.',
    desc: '범계에서 한 그릇에 정성을 담는 라멘 전문점, 우마이식당입니다. 본점의 기준을 다음 매장과 함께 이어갑니다.',
    contactLabel: 'Channel',
    links: [
      { label: 'Blog', href: '/blog' },
    ],
  },
}

// 한국어 전용 사이트 — 언어 토글은 제거했지만, 이후 영어 지원이 필요해지면
// 이 별칭을 실제 영어 번역 객체로 교체하면 된다.
const translations: Record<Lang, Translations> = {
  ko,
  en: ko,
}

export function getT(lang: Lang): Translations {
  return translations[lang]
}
